// (C) Copyright 2024 Hewlett Packard Enterprise Development LP
export const SERVICE_PROVISION_FEATURE = 'SERVICE_PROVISIONING'
